export default __webpack_public_path__ + "static/features-bg-a4c506ee71a50cb308c9dc8850af2dc1.png";